import { render, staticRenderFns } from "./ComentarioInput.vue?vue&type=template&id=5e0be8dc&"
import script from "./ComentarioInput.vue?vue&type=script&lang=js&"
export * from "./ComentarioInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports